import React, { useState, forwardRef, useEffect } from 'react';
import classnames from 'classnames';
import { Input } from 'antd';

export default forwardRef(function OthersPayment({ t, queryParams, setQueryParams }, ref) {
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState();

  const handleValidateOther = value => {
    if (!value) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.empty'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          methodName: null,
        },
      });
      return false;
    }

    if (value?.length > 100) {
      setError(true);
      setErrorMsg(t('properties.listing_management.payment_method.input_error.most'));
      setQueryParams({
        ...queryParams,
        isValid: false,
        data: {
          methodName: value,
        },
      });
      return false;
    }

    setError(false);
    setQueryParams({
      ...queryParams,
      isValid: true,
      data: {
        methodName: value,
      },
    });
    return true;
  };

  const handleOnChange = event => {
    const inputValue = event.target.value;
    handleValidateOther(inputValue);
  };

  useEffect(() => {
    ref.current = handleValidateOther;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <p className="method-desc" style={{ marginBottom: 8 }}>
        {t('properties.listing_management.payment_method.others.desc1')}
      </p>
      <p className="method-desc">
        {t('properties.listing_management.payment_method.others.desc2')}
      </p>
      <div className="method-input-wrapper">
        <div className="label">
          {t('properties.listing_management.payment_method.others.title')}
        </div>
        <div className={classnames('input-container', error && 'input-error-container')}>
          <Input
            onChange={handleOnChange}
            placeholder="Please input method name"
            defaultValue={queryParams?.data?.methodName}
          />
          {error && <span className="input-error">{errorMsg}</span>}
        </div>
      </div>
    </div>
  );
});
